import Colors from 'enums/Colors';
import styled from 'styled-components';

const PagePlaylistVideosStyled = {
    Container: styled.div`
        padding-left: 60px;
        width: 100%;
        justify-content: space-evenly;
        display: flex;

        height: 80vh;

        @media screen and (max-width: 1080px) {
            flex-direction: column;
            height: auto;
            padding-left: 20px;
        }
    `,

    PlayListLateral: styled.div`
        display: flex;
        flex-direction: column;
        gap: 20px;
        width: 300px;
        height: 100%;
        overflow: scroll;
        overflow-x: hidden;
        overflow-y: auto;
        margin-top: 30px;
        padding-bottom: 32px;
        background-color: white;

        @media screen and (max-width: 1080px) {
            overflow: hidden;
            width: 98%;
            align-self: flex-start;
        }
    `,

    ViewVideoPrincipal: styled.div`
        width: 60%;
        height: 100%;
        display: flex;
        flex-direction: column;
        padding: 20px;

        iframe {
            width: 1460px;
            height: 720px;
            border-radius: 8px;

            @media screen and (max-width: 2540px) {
                width: 1400px;
            }
            @media screen and (max-width: 2200px) {
                width: 1280px;
            }
            @media screen and (max-width: 2000px) {
                width: 1080px;
            }
            @media screen and (max-width: 1800px) {
                width: 920px;
                height: 500px;
            }
            @media screen and (max-width: 1495px) {
                width: 800px;
                height: 500px;
            }
            @media screen and (max-width: 1325px) {
                width: 720px;
                height: 400px;
            }
            @media screen and (max-width: 1230px) {
                width: 620px;
                height: 400px;
            }

            @media screen and (max-width: 1080px) {
                width: 920px;
                height: 600px;
            }

            @media screen and (max-width: 970px) {
                width: 820px;
                height: 500px;
            }
            @media screen and (max-width: 870px) {
                width: 780px;
                height: 400px;
            }
            @media screen and (max-width: 827px) {
                width: 100%;
                height: 400px;
            }
            @media screen and (max-width: 690px) {
                height: 380px;
            }
            @media screen and (max-width: 510px) {
                height: 320px;
            }
         
        }

        @media screen and (max-width: 1080px) {
            width: 100%;
        }
    `,

    HeaderContent: styled.div`
        display: flex;
        align-items: center;
        gap: 2rem;
        margin-top: 22px;

        h1 {
            font-family: 'Barlow';
            font-weight: 700;
            font-style: Bold;
            font-size: 22px;
            line-height: 150%;
            letter-spacing: -1%;
            vertical-align: middle;
            text-transform: uppercase;
            color: ${Colors.Blue};
        }

        p {
            width: 80px;
            font-family: 'Barlow';
            font-weight: 600;
            font-size: 18px;
            line-height: 100%;
            letter-spacing: -1%;
            vertical-align: middle;
            color: ${Colors.Blue};
        }

        @media screen and (max-width: 780px) {
            h1 {
                max-width: 60%;
                margin-top: 22px;
            }
        }

        @media screen and (max-width: 480px) {
            flex-direction: column-reverse;
            margin: 0;
            align-items: start;

            h1 {
                max-width: 100%;
            }
            margin-top: 32px;
        }
    `,

    Card: {
        Content: styled.div`
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            gap: 16px;
            border: 1px solid ${Colors.Grey13};
            min-height: 233px;
        `,

        Title: styled.h1`
            font-family: 'Barlow';
            font-weight: 700;
            font-style: Bold;
            font-size: 18px;
            line-height: 150%;
            letter-spacing: -1%;
            vertical-align: middle;
            text-transform: uppercase;
            color: ${Colors.Blue};
            margin: 6px;

            @media screen and (max-width: 1490px) {
                max-width: 60%;
            }
            @media screen and (max-width: 1280px) {
                margin-top: 20px;
            }
            @media screen and (max-width: 100px) {
                margin-top: 32px;
            }
        `,

        Description: styled.div`
            font-family: 'Barlow';
            font-weight: 400;
            font-style: 'Regular';
            font-size: 18px;
            line-height: 100%;
            letter-spacing: -1%;
            vertical-align: middle;
            color: ${Colors.Blue};
            max-width: 200px;
        `,

        Thumbnail: styled.div`
            position: relative;
            display: inline-block;
            overflow: hidden;
            height: 180px;
            width: 100%;
            cursor: pointer;
        `,

        Img: styled.img`
            height: 100%;
            width: 100%;
            object-fit: cover;
            display: block;
        `,
        Overlay: styled.div`
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: black;
            opacity: 0.5;
        `,

        Play: styled.div`
            position: absolute;
            top: 45%;
            left: 45%;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: white;
            width: 48px;
            height: 48px;
            border-radius: 100%;
        `,
    },

    ReguaLogo: styled.img`
        height: 220px;
        align-self: flex-start;
        object-fit: contain;
        border-radius: 8px;

        @media screen and (max-width: 680px) {
            margin-top: 22px;
            width: 100%;
        }
    `,

    Footer: styled.div`
        position: fixed;
        background-color: #ffffff;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 16px;
        padding: 10px;
        bottom: 0;

        @media screen {
        }
    `,
};

export default PagePlaylistVideosStyled;
